import { styled, css } from 'styled-components';
import { Media } from '../../../../../theme/Media.js';
export const ContentWrapper = styled.div `
  width: 100%;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.grey00_1};

  @media ${Media.xsMax} {
    padding: 12px;
    flex-wrap: wrap;
    gap: 8px;
  }

  ${({ $compact }) => $compact &&
    css `
      padding: 8px 12px;
    `}
`;
export const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  gap: 4px;
  ${({ theme }) => theme.typography.title};
  color: ${({ theme }) => theme.colors.black_1};

  @media ${Media.xsMax} {
    min-width: calc(100% - 36px - 8px); /* 36px icon button + 8px gap */
  }
`;
export const ActionsWrapper = styled.div `
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;

  @media ${Media.xsMax} {
    flex: 1 0 auto;
    flex-direction: column;
    gap: 8px;
  }
`;
export const TabsWrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.grey00_1};

  @media ${Media.smMin} {
    padding: ${({ $compact }) => ($compact ? '0' : '0 12px')};
  }
`;
export const CardHeaderWrapper = styled.div `
  overflow: hidden;

  & > ${ContentWrapper} + ${TabsWrapper} {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }
`;
